var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7998 4.00005C6.7998 3.33725 7.3386 2.80005 7.9998 2.80005C8.6626 2.80005 9.1998 3.34085 9.1998 4.00005V20C9.1998 20.6629 8.661 21.2001 7.9998 21.2001C7.337 21.2001 6.7998 20.6593 6.7998 20V4.00005ZM2.7998 11.2C2.7998 10.5372 3.3386 10 3.9998 10C4.6626 10 5.1998 10.5396 5.1998 11.2V12.8C5.1998 13.4628 4.661 14 3.9998 14C3.337 14 2.7998 13.4604 2.7998 12.8V11.2ZM19.9998 10C19.3386 10 18.7998 10.5372 18.7998 11.2V12.8C18.7998 13.4604 19.337 14 19.9998 14C20.661 14 21.1998 13.4628 21.1998 12.8V11.2C21.1998 10.5396 20.6626 10 19.9998 10ZM10.7998 9.19765C10.8011 8.53584 11.338 8.00005 11.9998 8.00005C12.6626 8.00005 13.1998 8.53725 13.1998 9.19765V14.8024C13.1985 15.4643 12.6616 16.0001 11.9998 16C11.337 16 10.7998 15.4628 10.7998 14.8024V9.19765ZM15.9998 6.00005C15.3386 6.00005 14.7998 6.53725 14.7998 7.20005V16.8C14.7998 17.4612 15.337 18 15.9998 18C16.661 18 17.1998 17.4628 17.1998 16.8V7.20005C17.1998 6.53885 16.6626 6.00005 15.9998 6.00005Z",
    fill: "#637282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3Icon);
export default __webpack_public_path__ + "static/media/mp3-icon.4268361f.svg";
export { ForwardRef as ReactComponent };